import { menuByPageId, routeFor } from '../../layouts/menuData.js';

// Role -> landing page id (from the Login design's role landing map).
const ROLE_LANDING_PAGE_ID = {
  driver: 73893,
  guest: 73895,
  noc: 73898,
  admin: 73871,
  field_technician: '7ebac161-add2-4d13-845d-7366ac5141e4', // Maintenance Tickets
  customer_care: 'f02d74e6-7c6b-4edc-89ad-9ca26880de3b', // Customer Disputes
  finance: 73902,
  user: 73899,
};

// Landing pages that are not menu entries (the guest walk-up checkout has no nav link).
const ROLE_LANDING_ROUTE = {
  guest: '/guest-checkout-session',
};

/** Route of the dashboard a role lands on; falls back to the 404 page until that page is built. */
export function landingRouteForRole(role) {
  if (ROLE_LANDING_ROUTE[role]) return ROLE_LANDING_ROUTE[role];
  const item = menuByPageId[ROLE_LANDING_PAGE_ID[role] || ROLE_LANDING_PAGE_ID.driver];
  return item ? routeFor(item) : '/404';
}

export const DEMO_ACCOUNTS = [
  { email: 'driver@chargeos.com', label: 'Driver', icon: 'fa-car', variant: 'outline-primary', title: 'Lands on Station Locator & Reservations' },
  { email: 'guest@chargeos.com', label: 'Guest', icon: 'fa-user-clock', variant: 'outline-secondary', title: 'Lands on Guest Walk-Up Checkout' },
  { email: 'noc@chargeos.com', label: 'NOC', icon: 'fa-network-wired', variant: 'outline-warning', title: 'Lands on NOC Fleet & Alarms' },
  { email: 'admin@chargeos.com', label: 'Admin', icon: 'fa-shield', variant: 'outline-danger', title: 'Lands on User & Role Management' },
  { email: 'tech@chargeos.com', label: 'Field Tech', icon: 'fa-wrench', variant: 'outline-info', title: 'Lands on Maintenance Tickets' },
  { email: 'care@chargeos.com', label: 'Support', icon: 'fa-headset', variant: 'outline-dark', title: 'Lands on Customer Dispute Console' },
  { email: 'finance@chargeos.com', label: 'Finance', icon: 'fa-coins', variant: 'outline-success', title: 'Lands on Financial Ledger' },
  { email: 'user@chargeos.com', label: 'Profile', icon: 'fa-user-circle', variant: 'outline-primary', title: 'Lands on User Profile & Vehicles' },
];

// Dev-only demo credential, supplied via env (VITE_DEMO_PASSWORD) rather than hard-coded in source.
export const DEMO_PASSWORD = import.meta.env.VITE_DEMO_PASSWORD || '';
